import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiGrid, FiCalendar, FiStar, FiLogOut, FiHome, FiCamera, FiCheckSquare } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const Sidebar = () => {
  const location = useLocation();
  const menuItems = [
    { name: 'Dashboard', path: '/admin', icon: FiGrid },
    { name: 'Bookings', path: '/admin/bookings', icon: FiCalendar },
    { name: 'Availability', path: '/admin/availability', icon: FiCheckSquare },
    { name: 'Reviews', path: '/admin/reviews', icon: FiStar },
    { name: 'Gallery', path: '/admin/gallery', icon: FiCamera },
  ];

  return (
    <div className="w-64 bg-brand-dark min-h-screen p-6 flex flex-col text-brand-cream sticky top-0 h-screen">
      <div className="mb-10 flex items-center gap-3">
        <div className="w-8 h-8 bg-brand-olive rounded-full flex items-center justify-center font-serif font-bold">R</div>
        <span className="font-serif text-xl tracking-wider uppercase font-bold">Admin Panel</span>
      </div>
      
      <nav className="flex-grow space-y-2">
        {menuItems.map((item) => (
          <Link 
            key={item.path} 
            to={item.path} 
            className={`flex items-center gap-3 px-4 py-3 rounded-sm transition-all duration-300 ${location.pathname === item.path ? 'bg-brand-olive text-white shadow-lg' : 'hover:bg-brand-olive/20 text-brand-light'}`}
          >
            <SafeIcon icon={item.icon} />
            <span className="text-sm uppercase tracking-widest">{item.name}</span>
          </Link>
        ))}
      </nav>

      <div className="pt-6 border-t border-brand-olive/30 space-y-2">
        <Link to="/" className="flex items-center gap-3 px-4 py-3 text-brand-light hover:text-white transition-colors">
          <SafeIcon icon={FiHome} />
          <span className="text-sm uppercase tracking-widest">Back to Website</span>
        </Link>
        <button className="w-full flex items-center gap-3 px-4 py-3 text-red-400 hover:bg-red-500/10 transition-colors">
          <SafeIcon icon={FiLogOut} />
          <span className="text-sm uppercase tracking-widest">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;